function generateGameID() {
    //Format isodate-time+6digit number
    const date = new Date()
    // const gameID = { datestamp: date.toISOString(), uuid: crypto.randomUUID() }
    const gameID = { datestamp: date.toISOString(), uuid: generateUUID() }
    // Old  const gameID = date.toISOString().substring(0, 16) + 'ID' + Math.round(Math.random() * 10000)
    console.log("GameID: ", gameID)

    return (gameID)
}

/**
 * Generates a UUID using a cryptographically secure method,
 * falling back for insecure contexts (like HTTP).
 * @returns {string} A version 4 UUID.
 */
function generateUUID() {
  // Use crypto.randomUUID() if available (HTTPS or localhost)
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  
  // Fallback for insecure contexts using crypto.getRandomValues()
  // Note: crypto.getRandomValues() is available over HTTP.
  if (window.crypto && window.crypto.getRandomValues) {
    // A version 4 UUID has the format xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
    // where y is one of [8, 9, a, or b].
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    
    // Set the UUID version (4) and variant (RFC4122) bits
    bytes[6] = (bytes[6] & 0x0f) | 0x40; // Version 4
    bytes[8] = (bytes[8] & 0x3f) | 0x80; // RFC4122 variant
    
    // Convert the bytes to a hex string and format
    const hex = [...bytes].map(b => b.toString(16).padStart(2, '0')).join('');
    
    // Insert the hyphens at the correct positions
    return [
      hex.slice(0, 8),
      hex.slice(8, 12),
      hex.slice(12, 16),
      hex.slice(16, 20),
      hex.slice(20, 32)
    ].join('-');
  }

  // Final fallback (for extremely old or restricted environments)
  // This is a less secure, but still functional, fallback.
  // Using Math.random() is strongly discouraged for any real security needs.
  console.warn("Using insecure Math.random() for UUID generation. Consider upgrading or using a library.");
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export default generateGameID 